import { Status } from "@package/grid-utils";

import { useGridSettingsStatusMap, useProductById, useProductConfigById } from "../../../data";

import { RootCellDisplay, FormulaTree } from "./components";
import { useTargetCell, useInsertPrecedentCurve, InsertCurveContext, RootEodSourceContext } from "./hooks";

type TracePrecedentsProps = {
  product: string;
  field: string;
  row: number;
};

export const TracePrecedents = ({ product, row, field }: TracePrecedentsProps) => {
  const configs = useProductConfigById(product);
  const config = configs.data?.find((c) => c.offset === row);
  const formula = config?.formula ?? "";

  const targetCell = useTargetCell();
  const insertCurve = useInsertPrecedentCurve();

  // If the cell being traced is on EOD source, hide LUT and username
  // throughout the modal — EOD has no last-edit metadata. Match the column
  // header's definition of "EOD" so curve-type EOD products are also covered.
  const rootStatus = useGridSettingsStatusMap()?.[product] ?? "listen";
  const rootProduct = useProductById(product);
  const isRootEodSource = Status.isEod(rootStatus) || rootProduct.data?.artis_type === "eod";

  return (
    <InsertCurveContext.Provider value={insertCurve}>
      <RootEodSourceContext.Provider value={isRootEodSource}>
        <div className="flex flex-col gap-3 pb-4 px-6 w-full min-w-3xl">
          <RootCellDisplay product={product} field={field} row={row} onMouseEnter={() => targetCell(product, row)} />
          {formula && (
            <div
              data-formula-container
              className="scrollbar-thin bg-surface-container-variant rounded-lg pt-4 pb-6 pr-3 pl-1 overflow-x-auto w-full min-w-0"
            >
              <FormulaTree formula={formula} row={row} />
            </div>
          )}
        </div>
      </RootEodSourceContext.Provider>
    </InsertCurveContext.Provider>
  );
};
